<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Permohonan Pengurusan Perubahan">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis" label="ID Premis" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_ternakan_id" :items="lkp_ternakan" label="Jenis Ternakan"/>
              <z-select style="margin:5px; " v-model="pencarian.lkp_status_perubahan_id" :items="lkp_status_perubahan" label="Jenis Pengurusan"/>
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
        <z-table title="Senarai Pengurusan Perubahan" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
            <template #button >
                <w-button dark class="green--bg ml1" v-on="on" :route="$route('baka.perubahan.permohonan',0)"  v-if="$zutil.anyRole(['2', '5'])">
                    <w-icon class="mr1" md >fal fa-plus</w-icon>PENDAFTARAN
                </w-button>
            </template>
          <template #header-label="{ header, label, index }">
            <template v-if="header.key == 'action'">
              <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
            <template v-else>
              {{ label }}
            </template>
          </template>
          <template #item-cell.action="{ item, label, header, index }">
            <template v-if="$zutil.anyRole(['1','6'])">
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <inertia-link :href="$route('baka.perubahan.permohonan.baka_show', item.id)" v-if="item.lkp_status_id ==30 || item.lkp_status_id ==18 || item.lkp_status_id ==21" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                  </template>
                  Papar
               </w-tooltip>
            </template>
            <w-flex class="flex justify-center">
               <w-tooltip top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['2','5'])" :route="$route('baka.perubahan.permohonan',item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                           <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['4'])" :route="$route('baka.perubahan.permohonan',item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                        </template>
                        Kemaskini
                     </w-tooltip>
         <template v-if="$zutil.anyRole(['4'])">       
            <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <inertia-link :href="$route('baka.perubahan.permohonan.baka_show', item.id)" v-if="item.lkp_status_id ==44 ||item.lkp_status_id ==31" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                 </template>
                  Papar 
                </w-tooltip>
            <w-tooltip md top color="white" bg-color="black" > 
                <template #activator="{ on }">
                    <inertia-link :href="$route('baka.perubahan.permohonan.baka_show', item.id)" v-if="item.lkp_status_id ==34 ||item.lkp_status_id == 30 ||item.lkp_status_id == 18 || item.lkp_status_id == 21  " v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                 </template>
                  Papar 
                </w-tooltip>
               </template>

            </w-flex>
          </template>
        </z-table>
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    segmenName: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'baka.perubahan.'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pensijilan Ternakan Baka', route: '/baka' },
        { label: 'Pengurusan Perubahan', route: '/baka/perubahan' },
      ],
      form : this.d_form,
      

      pencarian: {
         premis_id: '',
         lkp_status_perubahan_id: '',
         lkp_ternakan_id: '',
      },
      premis: [],
      lkp_status_perubahan :[],
      lkp_ternakan : [],
      
      
    }
  },
  methods: {
   
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getPerubahan(){
      this.$zcomm.get(this.api_service + 'lookup/status_perubahan', {}).then(res => {
        this.lkp_status_perubahan = res
      })
    },

    getPremis(){
     this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
       this.premis = res
     })
   },
   getTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
      })
    },


  },

  watch: {

  },
  mounted() {
   this.getPerubahan();
   this.getPremis();;
   this.getTernakan();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
